// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604201303/js/" + chunkId + "." + {"44":"7cc61cee","225":"a9195e36","481":"d23056cf","486":"b5e2340b","770":"533add2c"}[chunkId] + ".0.27087731219972633.chunk.js";
};